import type { Color } from 'culori/fn';
import { modeHsv, modeLrgb, modeRgb, parseHex, useMode } from 'culori/fn';

// These useMode calls are necessary for certain functions from culori that we
// use throughout the color picker (like formatHex and interpolate) to work.
// See https://culorijs.org/guides/tree-shaking/
// eslint-disable-next-line react-hooks/rules-of-hooks
const convertToRgbRaw = useMode(modeRgb);
// eslint-disable-next-line react-hooks/rules-of-hooks
const convertToHsvRaw = useMode(modeHsv);
// eslint-disable-next-line react-hooks/rules-of-hooks
useMode(modeLrgb); // required for wcagContrast fn to work

export const convertToHsv = (color: Color | string) => {
  let result: Color | undefined = undefined;

  if (typeof color === 'string') {
    const rgb = parseHex(color);
    if (rgb == null) {
      throw new Error(`Invalid hex color value: ${color}`);
    }

    result = convertToHsvRaw(rgb);
  }

  result = convertToHsvRaw(color);

  if (result == null) {
    throw new Error(`Invalid color value: ${JSON.stringify(color)}`);
  }

  return result;
};

export const convertToRgb = (color: Color | string) => {
  let result: Color | undefined = undefined;

  if (typeof color === 'string') {
    const rgb = parseHex(color);
    if (rgb == null) {
      throw new Error(`Invalid hex color value: ${color}`);
    }

    result = convertToRgbRaw(color);
  }

  result = convertToRgbRaw(color);

  if (result == null) {
    throw new Error(`Invalid color value: ${JSON.stringify(color)}`);
  }

  return result;
};
